"use strict";
exports.__esModule = true;
exports.SvgToolbarUpgradeFill = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgToolbarUpgradeFill = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M10 2a8 8 0 110 16 8 8 0 010-16zm.424 4.14a.713.713 0 00-.839-.007l-.09.076L7.218 8.47l-.071.082a.742.742 0 00-.017.863l.076.093.08.072a.713.713 0 00.85.017l.09-.077 1.021-1.015v5.03l.007.099c.048.358.35.634.716.634a.725.725 0 00.715-.634l.007-.1V8.446l1.081 1.074.082.07c.285.21.686.182.94-.082a.745.745 0 00.065-.948l-.078-.09-2.277-2.261-.08-.07z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=ToolbarUpgradeFill.js.map